var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isToDetail ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "30px"
    },
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": "搜索客户...",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.customerSearchText,
      callback: function ($$v) {
        _vm.customerSearchText = $$v;
      },
      expression: "customerSearchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "标签筛选",
      "label-in-value": "",
      "multiple": ""
    },
    on: {
      "on-change": _vm.choseTags
    },
    model: {
      value: _vm.tags,
      callback: function ($$v) {
        _vm.tags = $$v;
      },
      expression: "tags"
    }
  }, _vm._l(_vm.tagsList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCustomer
    }
  }), _vm.user.superAdmin || _vm.arrayIntersection(['salesAssist'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.UploadFileModal.openModal();
      }
    }
  }, [_vm._v("Excel导入客户")]) : _vm._e(), _vm.user.superAdmin || _vm.arrayIntersection(['salesAssist'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "loading": _vm.reloadCusStatusBtnLoading
    },
    on: {
      "click": function ($event) {
        return _vm.reloadCustomerStatusBtnClicked();
      }
    }
  }, [_vm._v("重载状态")]) : _vm._e(), _vm.user.superAdmin || _vm.arrayIntersection(['salesAssist'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    staticClass: "add-customer",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.AddNewCustomerDrawer.openDrawer();
      }
    }
  }, [_vm._v("新增客户")]) : _vm._e(), _c('Button', {
    staticClass: "customer-permissions",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/home/customerPermissions');
      }
    }
  }, [_vm._v("客户权限管理")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.customerList,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "tags",
      fn: function (_ref) {
        var row = _ref.row;
        return _vm._l(row.tags, function (tag) {
          return _c('span', [_c('Tag', [_vm._v(_vm._s(tag))])], 1);
        });
      }
    }], null, false, 2230267041)
  })], 1), _c('UploadFileModal', {
    ref: "UploadFileModal",
    on: {
      "uploadSuccess": _vm.loadCustomer
    }
  }), _c('AddNewCustomerDrawer', {
    ref: "AddNewCustomerDrawer"
  }), _c('BulkPermissionsModal', {
    ref: "BulkPermissionsModal"
  })], 1) : _c('router-view');

}
var staticRenderFns = []

export { render, staticRenderFns }